import styled from 'styled-components';
import { DocumentTable, TableCell, TableHead, TableRow } from '../common/common.styles';

export const ViewContainer = styled.div``;

export const ViewHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 30px;
`;

export const BackButton = styled.button`
  background: ${({ theme }) => theme.navActiveBg};
  border: none;
  color: ${({ theme }) => theme.heading};
  padding: 10px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ theme }) => theme.cardBorder};
  }
`;

// --- FIX: Added the missing ClientNameTitle style ---
export const ClientNameTitle = styled.h1`
  color: ${({ theme }) => theme.heading};
  margin: 0;
`;

export const CategorySection = styled.div`
  margin-bottom: 30px;
`;

export const CategoryTitle = styled.h2`
  color: ${({ theme }) => theme.text};
  font-weight: 500;
  font-size: 18px;
  padding-bottom: 10px;
  border-bottom: 1px solid ${({ theme }) => theme.cardBorder};
  margin-bottom: 20px;
`;

// Re-export table styles for use in the component if needed elsewhere
export { DocumentTable, TableHead, TableRow, TableCell };